"use client"

import React from "react"

interface BadgeGroup {
  color: string
  label: string
  types: string[]
  caras: number
  boletos: string
}

const BADGE_GROUPS: BadgeGroup[] = [
  {
    color: "#1F7B5C",
    label: "Verde",
    types: [
      "Residente FEMECOT",
      "Residente Internacional",
      "Residente NO FEMECOT",
      "Residente Estudiante",
    ],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#501168",
    label: "Morado",
    types: ["Ortopedista FEMECOT", "Ortopedista NO FEMECOT", "Ortopedista CMO"],
    caras: 4,
    boletos: "5",
  },
  {
    color: "#CA7C34",
    label: "Naranja",
    types: [
      "Ortopedista Internacional FEMECOT",
      "Ortopedista Internacional NO FEMECOT",
      "Ortopedista Internacional IOTA",
    ],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#000066",
    label: "Azul Oscuro",
    types: ["Enfermería", "Fisioterapeuta", "Médico No Ortopedista"],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#D54125",
    label: "Rojo",
    types: ["Expositor / Acceso Comercial"],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#33CC33",
    label: "Verde Lima",
    types: ["Espectador Comercial"],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#FFCC00",
    label: "Amarillo",
    types: ["Staff"],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#03193F",
    label: "Azul Marino",
    types: ["Profesor IOTA"],
    caras: 2,
    boletos: "N/A",
  },
  {
    color: "#941012",
    label: "Vino",
    types: ["Profesor / Profesora FEMECOT", "Ponente"],
    caras: 2,
    boletos: "N/A",
  },
]

const getTextColor = (hex: string): string => {
  const clean = hex.replace("#", "")
  const r = parseInt(clean.slice(0, 2), 16)
  const g = parseInt(clean.slice(2, 4), 16)
  const b = parseInt(clean.slice(4, 6), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 >= 128 ? "#000000" : "#ffffff"
}

const BadgeColorTable: React.FC = () => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="bg-gray-100 text-gray-600 uppercase tracking-wide">
            <th className="px-3 py-2 text-left border border-gray-200">Color de Gafete</th>
            <th className="px-3 py-2 text-left border border-gray-200">Tipo de Gafete</th>
            <th className="px-3 py-2 text-center border border-gray-200">Tipo</th>
            <th className="px-3 py-2 text-center border border-gray-200">Caras</th>
            <th className="px-3 py-2 text-center border border-gray-200">Boletos Rifa</th>
          </tr>
        </thead>
        <tbody>
          {BADGE_GROUPS.map((group, groupIndex) =>
            group.types.map((type, typeIndex) => (
              <tr
                key={`${group.color}-${typeIndex}`}
                className={groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 align-middle"
                  >
                    <div className="flex items-center gap-2">
                      <span
                        className="inline-flex items-center justify-center px-2 py-1 rounded-lg text-xs font-mono font-semibold shadow-sm whitespace-nowrap"
                        style={{
                          backgroundColor: group.color,
                          color: getTextColor(group.color),
                        }}
                        title={group.label}
                      >
                        {group.color.toUpperCase()}
                      </span>
                      <span className="text-gray-600 font-medium">{group.label}</span>
                    </div>
                  </td>
                )}
                <td className="px-3 py-2 border border-gray-200 text-gray-800">{type}</td>
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center text-gray-600 align-middle"
                  >
                    {group.label}
                  </td>
                )}
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center font-medium text-gray-800 align-middle"
                  >
                    {group.caras}
                  </td>
                )}
                {typeIndex === 0 && (
                  <td
                    rowSpan={group.types.length}
                    className="px-3 py-2 border border-gray-200 text-center text-gray-600 align-middle"
                  >
                    {group.boletos}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

export default BadgeColorTable
